<template>

  <div class="panel panel-clinic">

    <div class="panel-heading collapsed" href="#form_payments" data-toggle="collapse">

      <div class="arrow-down"></div>

      <h2 class="panel-title">Kontouppgifter & ersättningar</h2>

    </div>

    <div id="form_payments" class="panel-collapse collapse">

      <div class="panel-body">

        <div class="form-horizontal">

          <div class="account">

            <h3>Kontouppgifter</h3>

            <div class="input-group col-md-25 left">
              <div style="width:100%; margin-bottom:20px;">
                <input type="checkbox" id="faktbolcheck" v-on:change="setException()" v-model="clinic.payment_exception"
                       style="margin-right:5px;" /> <label for="faktbolcheck"
                                                           style="font-weight:normal; cursor:pointer;">Denna massör
                fakturerar via faktureringsbolag</label>
              </div>
              <div style="width:100%;" v-if="clinic.payment_exception == 1">
                <input type="text" v-model="clinic.payment_exception_name" placeholder="Namn på faktureringsbolag"
                       class="form-control" />
              </div>
            </div>

            <div class="clearfix"></div>

            <div class="input-group col-md-25 left" v-if="clinic.payment_exception != 1">

              <div class="input-group-btn">
                <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false">{{ accountTypeInText }} <span class="caret"></span>
                </button>
                <ul class="dropdown-menu">
                  <li><a v-on:click="clearFields(1)">Konto</a></li>
                  <li><a v-on:click="clearFields(2)">Bankgiro</a></li>
                  <li><a v-on:click="clearFields(3)">Plusgiro</a></li>
                </ul>
              </div>
              <input v-if="clinic.payment_type" type="text" class="form-control" v-model="clinic.payment_account"
                     v-bind:placeholder="accountPlaceholder">
            </div>

            <div v-if="clinic.payment_type == 1" class="col-md-25 right">

              <input type="text" class="form-control" style="float:left; width:50%;" v-model="clinic.payment_bank"
                     placeholder="Bank" />
              <input type="text" class="form-control" style="float:left; width:calc(50% - 15px); margin-left:15px;"
                     v-model="clinic.payment_clearing" placeholder="Clearing" />

            </div>

            <div class="clearfix"></div>

          </div>

        </div>

        <h3 style="margin-top:40px;">Ersättningar<a href="/customers/new" class="btn btn-default btn-sm"
                                                    style="margin-left:8px; margin-top-3px;" v-bind:href="'#item-1-new'"
                                                    data-toggle="collapse">Ny period</a></h3>

        <div class="panel panel-default">

          <div class="panel-heading">

            <div class="row">
              <div class="col-md-24 col-xs-30">Period</div>
              <div class="col-md-8 hidden-sm hidden-xs">Bekräftade till massör?</div>
              <div class="col-md-8 hidden-sm hidden-xs">Visade av massör?</div>
              <div class="col-md-8 hidden-sm hidden-xs"></div>
            </div>

          </div>

        </div>

        <div class="panel panel-default">

          <div v-bind:id="'item-1-new'" class="collapse">

            <div class="panel-body">

              <b>Giltigt från:</b>

              <month-picker :disabled-to="disabledTo" :value="valid_from"
                            @changed="valid_from = arguments[0]"></month-picker>

              <div class="form-inline" style="margin:10px 0 15px 0;">

                <div v-for="account in accounts" class="form-group accountCol"
                     v-bind:class="{'hasContract': account.hasContract}">

                  <h5><b>{{ account.title }}</b></h5>
                  <div class="input-group" v-for="duration in account.durations">
                    <span class="input-group-addon">{{ duration.minutes }} minuter</span>
                    <input type="text" class="form-control" v-model="duration.price" placeholder="Summa i kronor" />
                  </div>

                </div>
              </div>

              <button class="btn btn-primary pull-right" v-on:click="save()" style="margin-left:10px;">
                Spara
              </button>

              <button class="btn btn-info pull-right" v-bind:href="'#item-1-new'" data-toggle="collapse">
                Avbryt
              </button>

              <div v-if="showWarning != null">
                Alla priser är inte ifyllda, tryck på spara igen för att fortsätta.
              </div>

            </div>

          </div>

        </div>

        <div v-for="group in priceGroups">

          <div class="panel panel-default">

            <div class="panel-heading amounts collapsed" v-bind:href="'#item-1'+group.id" data-toggle="collapse">

              <div class="row">
                <div class="col-md-24 col-xs-45">{{ title(group.valid_from) }}</div>
                <div class="col-md-8 hidden-sm hidden-xs"><img src="/images/check.png" v-if="group.clinic_notified == 1"
                                                               style="width:22px;" /></div>
                <div class="col-md-8 hidden-sm hidden-xs"><img src="/images/check.png" v-if="group.clinic_seen == 1"
                                                               style="width:22px;" /></div>
                <div class="col-md-8 hidden-sm hidden-xs">
                  <button class="btn btn-sm btn-info" v-on:click.stop="notify(group.id)">Bekräfta ersättning</button>
                </div>
                <div class="arrow-down small"></div>
              </div>

            </div>

            <div v-bind:id="'item-1'+group.id" class="collapse">

              <div class="panel-body">

                <div class="form-inline" style="margin:10px 0 15px 0;">

                  <div v-for="(account, key) in group.prices" class="form-group accountCol">

                    <h5><b>{{ entryType(key) }}</b></h5>
                    <div class="input-group" v-for="duration in account">
                      <span class="input-group-addon">{{ duration.duration.minutes }} minuter</span>
                      <input
                        v-show="group.id != active_edit"
                        v-model="duration.price"
                        type="text" class="form-control"
                        placeholder="Summa i kronor"
                        disabled="disabled" />

                      <input
                        v-show="group.id == active_edit"
                        v-model="duration.price"
                        type="text"
                        class="form-control"
                        placeholder="Summa i kronor" />
                    </div>

                  </div>
                </div>

                <button v-on:click="active_edit = group.id" v-show="group.id != active_edit && canUpdate(group)"
                        class="btn btn-primary pull-right" style="margin-left:10px;">
                  Editera
                </button>

                <button v-on:click="saveEdit(group)" v-show="group.id == active_edit" class="btn btn-primary pull-right"
                        style="margin-left:10px;">
                  Spara
                </button>

                <button v-show="group.id == active_edit" v-on:click="active_edit = null"
                        class="btn btn-info pull-right">
                  Avbryt
                </button>

              </div>

            </div>

          </div>

        </div>

      </div>

    </div>

  </div>

</template>

<script>

import mixin from './mixin'

let lastTitle = ''

export default {

    mixins: [mixin],

    props: {

        priceGroups: {
            required: true
        }

    },

    data () {
        return {

            saved: false,

            valid_from: null,
            active_edit: null,
            lastTitle: '',
            showWarning: null,
            ignoreWarning: false,

            durations: this.payments.durations,

            disabledTo: moment().startOf('month')

        }
    },

    computed: {

        accountTypeInText () {
            if (this.clinic.payment_type == 1) {
                return 'Konto'
            }
            if (this.clinic.payment_type == 2) {
                return 'Bankgiro'
            }
            if (this.clinic.payment_type == 3) {
                return 'Plusgiro'
            }

            return 'Välj kontotyp'
        },

        accountPlaceholder () {
            if (this.clinic.payment_type == 1) {
                return 'Kontonummer'
            }
            if (this.clinic.payment_type == 2) {
                return 'Bankgironummer'
            }
            if (this.clinic.payment_type == 3) {
                return 'Plusgironummer'
            }

            return ''
        },

        accounts: function () {
            const self = this

            // console.log('all durations ');
            // console.log(self.durations);

            const rows = []

            if (self.durations != null) {
                var hasContract = null
                if (self.clinic.contract_internal == 1) {
                    hasContract = true
                }

                rows[0] = { account_id: '1', title: 'Mottagning', hasContract: hasContract, durations: [] }
                self.durations.forEach(function (duration, key) {
                    rows[0].durations[key] = { duration_id: duration.id, minutes: duration.minutes, price: null }
                })

                var hasContract = null
                if (self.clinic.contract_external == 1) {
                    hasContract = true
                }

                rows[1] = { account_id: '2', title: 'Företag', hasContract: hasContract, durations: [] }
                self.durations.forEach(function (duration, key) {
                    rows[1].durations[key] = { duration_id: duration.id, minutes: duration.minutes, price: null }
                })

                var hasContract = null
                if (self.clinic.contract_pt == 1) {
                    hasContract = true
                }

                rows[2] = { account_id: '4', title: 'PT', hasContract: hasContract, durations: [] }
                self.durations.forEach(function (duration, key) {
                    rows[2].durations[key] = { duration_id: duration.id, minutes: duration.minutes, price: null }
                })
            }

            // console.log('rows to return ');
            // console.log(rows)

            return rows
        }

    },

    methods: {

        clearFields (type) {
            this.clinic.payment_type = type
            this.clinic.payment_bank = ''
            this.clinic.payment_clearing = ''
            this.clinic.payment_account = ''
        },

        setException () {
            console.log('set exception')

            if (this.clinic.payment_exception == 1) {
                this.clinic.payment_exception_name = null
            }

            this.clearFields(null)
        },

        entryType: function (account_id) {
            if (account_id == 1) {
                return 'Mottagning'
            }

            if (account_id == 4) {
                return 'PT'
            }

            return 'Företag'
        },

        canUpdate: function (group) {
            // console.log('date to check');
            // console.log(group.valid_from);

            const lastAccounted = moment(this.payments.lastAccountedYearAndMonth.year + '-' + this.payments.lastAccountedYearAndMonth.month).endOf('month')
            if (moment(group.valid_from).isAfter(lastAccounted)) {
                return true
            }

            return false
        },

        save: function () {
            const self = this

            console.log('accounts')
            console.log(self.accounts)

            if (self.payments.periods[0]) {
                let error = ''

                _.forEach(self.accounts, function (account) {
                    const lastPeriodPrices = self.payments.periods[0].prices[account.account_id]

                    _.forEach(account.durations, function (duration) {
                        const lastPeriodPriceForDuration = _.find(lastPeriodPrices, ['duration_id', duration.duration_id])
                        console.log('duration.price for account_id ' + account.account_id + ' duration id ' + duration.duration_id)
                        console.log(duration.price)

                        console.log('lastPeriodPriceForDuration for account_id ' + account.account_id + ' duration id ' + duration.duration_id)
                        console.log(lastPeriodPriceForDuration)

                        if ((!duration.price || duration.price == 0) && lastPeriodPriceForDuration.price != 0) {
                            error += 'Ersättning saknas för ' + account.title + ' ' + lastPeriodPriceForDuration.duration.name + '\n'
                        }
                    })
                })

                if (error) {
                    error = 'Du har missat att ange några belopp som fanns i föregående period. Klicka avbryt om du vill justera dessa först. Klicka Ok för att godkänna perioden med saknade belopp.\n\n' + error
                }

                if (error && !confirm(error)) {
                    return
                }
            }

            this.$http.post('/clinics/prices/add', {
                clinic: self.clinic,
                valid_from: self.valid_from,
                accounts: self.accounts
            }).then((response) => {
                console.log(response.body)

                if (response.body.error == true) {
                    alert(response.body.message)
                } else {
                    // self.currentPrices = response.body;
                    self.showWarning = null
                    self.ignoreWarning = false

                    $('#item-1-new').collapse('hide')

                    bus.$emit('refresh-data', 1)
                    bus.$emit('notify', 'Priset har sparats.')
                }
            }, (response) => {
                console.log(JSON.stringify(response))
            })
        },

        saveEdit: function (group) {
            console.log('running save dit')

            const self = this

            this.$http.post('/clinics/prices/update', group).then((response) => {
                console.log(response.body)

                self.active_edit = null

                $('#item-1' + group.id + '').collapse('hide')

                bus.$emit('notify', 'Priset har uppdaterats.')

                /*

              bus.$emit('refresh-data', 1)
              */
            }, (response) => {
                console.log(JSON.stringify(response))
            })
        },

        notify: function (id) {
            const self = this

            this.$http.post('/clinics/prices/notify', { clinic: self.clinic, period_id: id }).then((response) => {
                console.log(response.body)
                console.log('notified clinic about price')

                bus.$emit('refresh-data', 1)
                bus.$emit('notify', 'Mail till massör är skickat.')
            }, (response) => {
                console.log(JSON.stringify(response))
            })
        },

        title: function (key) {
            const theKey = key.substr(0, 7)

            if (lastTitle) {
                lastTitle = 'till ' + lastTitle
            }

            const title = 'Från ' + theKey + ' ' + lastTitle

            lastTitle = theKey

            return 'Från ' + theKey
        }

    }

}

</script>
